/** Return true when polling should retry instead of abandoning a live job. */
export function isTransientPollingStatus(status) {
  if (status === undefined || status === null) return true;
  const numeric = Number(status);
  return numeric === 408 || numeric === 425 || numeric === 429 || numeric >= 500;
}

/** Internal finalization is committed/non-cancellable but still UI-active. */
export function isAnalysisJobActive(status) {
  return status === "queued" || status === "running" || status === "finalizing";
}
